import React, { Component } from "react";

import FormatUtils from "../../utils/formatUtils";

class AssignmentBody extends Component {
  render() {
    return (
      <div>
        <div className="data-line">
          <span>Placement Specialist: </span>
          <span className="value-data">{this.props.data.AccountManager}</span>
        </div>
        <div className="data-line">
          <span>Last Submit Date: </span>
          <span className="value-data">
            {FormatUtils.formatDate(this.props.data.LastSubmittedDate)}
          </span>
        </div>
        <div className="data-line">
          <span>First Policy Date: </span>
          <span className="value-data">
            {FormatUtils.formatDate(this.props.data.FirstPolicyDate)}
          </span>
        </div>
        <div className="data-line">
          <span>Client Status: </span>
          <span className="value-data">{this.props.data.ClientStatus}</span>
        </div>
      </div>
    );
  }
}

export default AssignmentBody;
